window.addEventListener('DOMContentLoaded', () => {
	const swiper = document.querySelector('.ab-featured-collection');
	const data = swiper.querySelector(`.swiper-data-handler`);
	const sectionId = data.getAttribute('data-section');
	const mySwiper = data.getAttribute('data-class');
	const swipeEffect = data.getAttribute('data-effect');
	const pagination = (data.getAttribute('data-pagination'));
	const buttons = (data.getAttribute('data-buttons'));
	const autoplay = (data.getAttribute('data-autoplay'));
	const disableOnInteraction = (data.getAttribute('data-disable'));
	const colsDesktop = Number(data.getAttribute('data-col-desktop'));
	const colsMobile = Number(data.getAttribute('data-col-mobile'));
	const colsTablet = Number(data.getAttribute('data-col-tablet'));
	
	const colDesktopGap = Number(data.getAttribute('data-col-desktop-gap'));
	const colMobileGap = Number(data.getAttribute('data-col-mobile-gap'));

	let myPagination = document.querySelector(`.swiper-pagination[data-target="${mySwiper}"]`)

	const paginationObj = {
		el: myPagination,
		clickable: true,
	};

	let mySwiperNext = document.querySelector(`.swiper-button-next[data-target="${mySwiper}"]`)
	let mySwiperPrev = document.querySelector(`.swiper-button-prev[data-target="${mySwiper}"]`)

	const navigationObj = {
		nextEl: mySwiperNext,
		prevEl: mySwiperPrev,
	};

	const autoplayObj = {
		delay: 3000,
		disableOnInteraction: true,
		pauseOnMouseEnter: true,
	};

	const swiperObj = {
		spaceBetween: 20,
    draggable: false,
		keyboard: {
			enabled: true,
		},
		breakpoints: {
			212: {
				slidesPerView: colsMobile,
				spaceBetween: colMobileGap,
			},
			768: {
				slidesPerView: colsMobile, 
				spaceBetween: colMobileGap,
			},
			1024:{
				slidesPerView: colsTablet,
				spaceBetween: colDesktopGap,
			},
			1440: {
				slidesPerView: colsDesktop,
				spaceBetween: colDesktopGap,
			},
		},
	}
	
	if (pagination === 'true') {
		swiperObj.pagination = paginationObj;
	}

	if (buttons === 'true') {
		swiperObj.navigation = navigationObj;
	}

	if (autoplay === 'true') {
		swiperObj.autoplay = autoplayObj;
	}
	
  const swiperInstance = new Swiper(`.${mySwiper}`, swiperObj);
  swiperInstance.on('slideChange', function (swiper) {
    myPagination.querySelector('.swiper-pagination-bullet-active').classList.remove('swiper-pagination-bullet-active')
    myPagination.querySelectorAll('.swiper-pagination-bullet')[swiper.realIndex].classList.add('swiper-pagination-bullet-active')
  });
});
